import constants from './constants';
import {
  validateSsn,
  validateEmail,
  validatePostalCode,
  validateNumber,
  validateLandlordEmail,
  validateLandlordPhone,
  validateLandlordName,
} from '../../components/InputField/validations';

const initialState = {
  isFormValid: false,
  isFormDirty: false,
};

export default function (state = initialState, action) {
  const { type, field } = action;
  switch (type) {
    case constants.BLUR_FIELD:
      return {
        ...state,
        [field.name]: {
          ...state[field.name],
          focus: false,
          blur: true,
        },
      };

    case constants.DESTROY_FIELD: {
      const { [field.name]: toDestroy, ...rest } = state;
      return {
        ...rest,
      };
    }

    case constants.FOCUS_FIELD:
      return {
        ...state,
        [field.name]: {
          ...state[field.name],
          focus: true,
          blur: false,
        },
      };

    case constants.INITIALIZE_FIELD:
      return {
        ...state,
        [field.name]: {
          value: field.initialValue,
          error: '',
          valid: false,
          validation: field.validation || 'none',
          dirty: false,
          focus: false,
          blur: false,
          type: field.type,
        },
      };

    case constants.SYNC_FIELD: {
      const {
        field: { currentApplicant },
      } = action;
      const { value, validation } = state[field.name];
      const validateFunc = validationTypes(value, currentApplicant)[validation];
      let valid = false;
      let error = '';
      if ((value || value === 0) && validateFunc()) valid = true;
      if (!valid) error = getErrorMessage()[validation];

      return {
        ...state,
        [field.name]: { ...state[field.name], valid, error },
        isFormValid: checkTotalValidity(state),
        isFormDirty: checkTotalDirty(state),
      };
    }

    case constants.UPDATE_FIELD:
      return {
        ...state,
        [field.name]: {
          ...state[field.name],
          value: field.value,
          dirty: true,
        },
      };

    case constants.SUBMIT_FORM:
      return {
        ...state,
        isFormDirty: false,
        isFormValid: false,
      };

    default:
      return state;
  }
}

function getErrorMessage() {
  return {
    ssn: 'Personnummer måste anges med 10 siffror, t.ex. 801012-XXXX',
    email: 'E-postadress måste anges på detta vis: adress@mailhost.com',
    landlordEmail:
      'Hyresvärdens e-postadress måste anges på detta vis: adress@mailhost.com och får inte vara samma som någon av bytesparterna',
    landlordPhone:
      'Hyresvärdens telefonnummer kan inte vara samma som någon av bytesparterna',
    landlordName:
      'Hyresvärdens namn måste vara det officiella namnet på Hyresvärden, t.ex. "Stockholmshem"',
    zip: 'Postnummer måste anges med 5 siffror',
    number: 'Fältet får endast innehålla siffror',
    none: 'Detta fält måste fyllas i korrekt',
  };
}

function validationTypes(value, currentApplicant) {
  return {
    ssn: () => validateSsn(value),
    email: () => validateEmail(value),
    landlordEmail: () => validateLandlordEmail(value, currentApplicant),
    landlordPhone: () => validateLandlordPhone(value, currentApplicant),
    landlordName: () => validateLandlordName(value),
    zip: () => validatePostalCode(value),
    number: () => validateNumber(value),
    none: () => true,
  };
}

function checkTotalValidity(state) {
  const { isFormValid, isFormDirty, ...rest } = state;
  const invalidArray = Object.values({ ...rest }).filter((r) => {
    if (r.type === 'checkbox' && !r.valid) return false;
    return (
      (!r.valid && r.dirty && r.validation !== 'none') || (!r.value && r.dirty)
    );
  });
  return !invalidArray.length;
}

function checkTotalDirty(state) {
  const { isFormValid, isFormDirty, ...rest } = state;
  return Boolean(Object.values({ ...rest }).filter((r) => r.dirty).length);
}



// WEBPACK FOOTER //
// ./src/features/Form/reducer.js